import styled from '@emotion/styled';

const Separator = styled.hr`
  width: 95%;
  text-align: left;
  margin-left: 0;
  margin-top: 15px;
  margin-bottom: 15px;
`;

export default Separator;
